import api from './../helpers/api'

class FinancialService {

    get_accounts(includeInactive = false) {
        return api.get('/financial_accounts', { params: includeInactive ? { include_inactive: 1 } : {} });
    }

    get_account(id) {
        return api.get(`/financial_accounts/${id}`);
    }

    create_account(account) {
        return api.post('/financial_accounts', {
            name:            account.name,
            type:            account.type || 'other',
            opening_balance: account.opening_balance || 0,
            description:     account.description || '',
        });
    }

    update_account(id, account) {
        return api.put(`/financial_accounts/${id}`, {
            name:        account.name,
            type:        account.type || 'other',
            description: account.description || '',
            is_active:   account.is_active,
        });
    }

    get_transactions(id, params = {}) {
        return api.get(`/financial_accounts/${id}/transactions`, { params });
    }

    deposit(payload) {
        return api.post('/financial_accounts/deposit', payload);
    }

    withdraw(payload) {
        return api.post('/financial_accounts/withdraw', payload);
    }

    transfer(payload) {
        return api.post('/financial_accounts/transfer', payload);
    }
}

export default new FinancialService();
